import api from './api';

const planningDocsApi = {
  getAll: (interventionId, config = {}) =>
    api.get(`/planning/${interventionId}/documents`, config),

  presign: (interventionId, { filename, contentType }) =>
    api.post(`/planning/${interventionId}/documents/presign`, { filename, contentType }),

  // `echange_id` facultatif : rattache en plus le document à un échange client.
  confirm: (interventionId, { key, filename, contentType, size, echange_id }) =>
    api.post(`/planning/${interventionId}/documents/confirm`, { key, filename, contentType, size, echange_id }),

  uploadFile: (interventionId, formData) =>
    api.post(`/planning/${interventionId}/documents/upload-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  rename: (interventionId, docId, nom) =>
    api.patch(`/planning/${interventionId}/documents/${docId}`, { nom }),

  delete: (interventionId, docId) =>
    api.delete(`/planning/${interventionId}/documents/${docId}`),
};

export default planningDocsApi;
